import { AddWidgetType } from '..'
import { Box, Stack } from '@dtx-company/design-system/src'
import { FC, FormEvent, ReactElement, ReactNode } from 'react'
import { LinkMetaType, SocialLinkType } from '@dtx-company/inter-app/src/constants/linkTypes'
import { LinkType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { stopPropagationEvents } from '../../../components/profile/PageEditor/components/LinkEditDrawer/LinkEditDrawer.utils'

export interface FormProps {
  widgetObj: AddWidgetType | SocialLinkType
  order: number
  curr?: LinkType
  isUsernameLink?: boolean
  handleClose: () => void
  defaultFields?: {
    imageUrl?: string
    link?: string
    title?: string
    meta?: LinkMetaType
  }
}

interface FormPropsWrapper {
  children: ReactNode
  padding?: string
  title: ReactElement
  noPreview?: boolean
  disableAutoSpace?: boolean
  subheader?: ReactNode
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
}

export const StyledForm: FC<FormPropsWrapper> = ({
  children,
  onSubmit,
  disableAutoSpace = false,
  title,
  subheader = null,
  padding
}: FormPropsWrapper) => {
  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        onSubmit(e)
      }}
      style={{ width: '100%' }}
    >
      <Stack
        sx={theme => ({
          maxwidth: theme.spacing(150),
          width: '100%',
          p: { xs: `${padding} !important`, lg: 0 },
          borderColor: { lg: 'transparent' },
          borderRadius: { lg: 3 }
        })}
      >
        {title}
        {subheader}
        <Box
          sx={{
            marginTop: 3,
            ...(!disableAutoSpace && {
              '& > div': {
                marginBottom: 4.5
              }
            })
          }}
        >
          {children}
        </Box>
      </Stack>
    </form>
  )
}

export const StyledFormV2: FC<{
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
  children: ReactNode
}> = ({ children, onSubmit }) => {
  return (
    <form
      onSubmit={onSubmit}
      {...stopPropagationEvents}
      style={{ width: '100%', padding: '16px 0' }}
    >
      {children}
    </form>
  )
}
